/* unplugin-vue-components disabled */import script from "./dyzModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./dyzModal.vue?vue&type=script&setup=true&lang=ts"

import "./dyzModal.vue?vue&type=style&index=0&id=3e92c45b&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e92c45b"]])

export default __exports__